export const VAULT_ACCOUNT_TYPES = {
  mc: 'MasterCard',
  visa: 'Visa',
  amex: 'American Express',
  disc: 'Discover',
  jcb: 'JCB (Japan Credit Bureau)',
  diners: 'Diners Club',
};

export const UNKNOWN_VAULT_ACCOUNT_TYPE_TITLE = 'Unknown';



// WEBPACK FOOTER //
// ./src/constants/payments/vault-account-types.js